setLiveAccessEventList